










































import {Vue, Component, Prop} from "vue-property-decorator";
import FieldAutomationsTableDeck from "./FieldAutomationsTableDeck.vue";
import AddAutomationModal from "./AddAutomationModal.vue";
// @ts-ignore
import store from "../../../store";
import {AdminAutomations} from "../../../../types/automations-list";
import EventApi from "../../../api/EventsApi";

@Component({
    components: {AddAutomationModal, FieldAutomationsTableDeck},
})

export default class FieldAutomationsTable extends Vue {
    @Prop({required: true}) private field!: any;

    private addAutomationModalIsVisible: boolean = false;

    private filters = [
        {id: 'all', selected: false},
        {id: 'master', selected: true}
    ];

    private get automationsList(): AdminAutomations.List | null
    {
        return store.getters.getAutomationsList;
    }

    private openAddAutomationModal(): void
    {
        this.addAutomationModalIsVisible = true;
    }

    private closeAddAutomationModal(): void
    {
        this.addAutomationModalIsVisible = false;
    }

    private closeAutomations(): void
    {
        EventApi.triggerEvent(EventApi.CLOSE_AUTOMATIONS);
    }
}
